import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ReduxState } from "../../../../../redux";
import { setOption } from "../../../../../redux/reducers/DownloadOptions";
import { useLocalStorage } from "../../../../../utils/prefs";
import { loadPreferenceServer } from "../../../../../docuclipper/api";

const options = [
  {
    value: "DD/MM/YYYY",
    label: "DD/MM/YYYY",
  },
  {
    value: "MM/DD/YYYY",
    label: "MM/DD/YYYY",
  },
  {
    value: "YYYY-MM-DD",
    label: "YYYY-MM-DD",
  },
];

const ALLOWED_FORMATS = options.map((o) => o.value);

export const DateFormatOptions: React.FC = () => {
  const dispatch = useDispatch();

  const { options: reduxOptions } = useSelector(
    (state: ReduxState) => state.DownloadOptions
  );

  const [selectedOptionLS, setSelectedOptionLS] = useLocalStorage(
    `docuclipper.prefs.dateFormat`,
    ""
  );

  React.useEffect(() => {
    let cancelled = false;
    if (!selectedOptionLS) {
      // Seed from server-side Profile preference (Preferences.dateFormat)
      // before falling back to the redux default. This keeps the download
      // dropdown in sync with what the user set under Account > Profile.
      (async () => {
        let serverFormat = "";
        try {
          const pref = await loadPreferenceServer({ key: "dateFormat" });
          if (pref && pref.value && ALLOWED_FORMATS.includes(pref.value)) {
            serverFormat = pref.value;
          }
        } catch (err) {
          // Ignore. Fall back to redux default.
        }
        if (cancelled) return;
        setSelectedOptionLS(
          serverFormat ||
            reduxOptions[`docuclipper.prefs.dateFormat`] ||
            "YYYY-MM-DD"
        );
      })();
    }
    return () => {
      cancelled = true;
    };
  }, []);

  React.useEffect(() => {
    dispatch(
      setOption({
        key: `docuclipper.prefs.dateFormat`,
        value: selectedOptionLS || "YYYY-MM-DD",
      })
    );
  }, [selectedOptionLS]);

  const value = reduxOptions[`docuclipper.prefs.dateFormat`];

  return (
    <Select
      options={options}
      value={{ value, label: value }}
      onChange={(value) => {
        setSelectedOptionLS(value ? value.value || "" : "");
        dispatch(
          setOption({
            key: `docuclipper.prefs.dateFormat`,
            value: value ? value.value || "" : "",
          })
        );
      }}
    />
  );
};
export default DateFormatOptions;
